import {
  apiClient,
  type UpdateNotDispatchedShipmentOrderDto,
  type ShipmentOrderExEntity
} from '@/libs/api'

export type UpdateNotDispatchedShipmentOrderRequest = {
  tenantKey: string
  orderId: number
  dto: UpdateNotDispatchedShipmentOrderDto
}

export const updateNotDispatchedShipmentOrder = async ({
  tenantKey,
  orderId,
  dto
}: UpdateNotDispatchedShipmentOrderRequest): Promise<ShipmentOrderExEntity> => {
  const { data } = await apiClient
    ._tenant(tenantKey)
    .shipment_orders._id(orderId)
    .not_dispatched.$put({ body: dto })

  return data
}
